import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {BoxScoresWidgetController} from "../box-scores-widget.controller";

export class BoxScoresWidgetProps extends BaseModuleProps {
  controller: BoxScoresWidgetController;
}
